export interface ErrorPayload {
  status?: number;
  response?: { status?: number };
}

export function isUnauthorizedError(payload: ErrorPayload | undefined): boolean {
  return payload?.status === 401 || payload?.response?.status === 401;
}
